
export function ContactDetails() {
  return (
    <section id="contact-details" className="py-20 bg-[#1A2332]">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="text-center mb-12">
          <h2 className="font-display text-3xl lg:text-4xl font-bold text-white mb-4">
            Get In Touch
          </h2>
          <p className="text-gray-300 text-lg">
            Have a missed-call problem, slow follow-up, or a booking issue? Reach out and we’ll point you in the right direction.
          </p>
        </div>

        <div className="grid md:grid-cols-3 gap-8">
          {/* Address Card */}
          <div className="bg-white/10 backdrop-blur-sm rounded-2xl p-8 text-center hover:bg-white/15 transition-all duration-300 group">
            <div className="w-16 h-16 mx-auto mb-6 rounded-full bg-primary/20 flex items-center justify-center group-hover:scale-110 transition-transform duration-300">
              <i className="ri-map-pin-line text-3xl text-primary"></i>
            </div>
            <h3 className="font-display text-xl font-semibold text-white mb-3">
              Visit Us
            </h3>
            <a 
              href="https://maps.google.com/?q=1114+N.+Leroy+St,+Fenton,+MI+48430" 
              target="_blank" 
              rel="noopener noreferrer"
              className="text-gray-300 hover:text-primary transition-colors cursor-pointer leading-relaxed"
            >
              1114 N. Leroy St<br />
              Fenton, MI 48430
            </a>
          </div>

          {/* Email Card */}
          <div className="bg-white/10 backdrop-blur-sm rounded-2xl p-8 text-center hover:bg-white/15 transition-all duration-300 group">
            <div className="w-16 h-16 mx-auto mb-6 rounded-full bg-primary/20 flex items-center justify-center group-hover:scale-110 transition-transform duration-300">
              <i className="ri-mail-line text-3xl text-primary"></i>
            </div>
            <h3 className="font-display text-xl font-semibold text-white mb-3">
              Email Us
            </h3>
            <a 
              href="mailto:support@dino-nuggets.com"
              className="text-gray-300 hover:text-primary transition-colors cursor-pointer"
            >
              support@dino-nuggets.com
            </a>
          </div>

          {/* Phone Card */}
          <div className="bg-white/10 backdrop-blur-sm rounded-2xl p-8 text-center hover:bg-white/15 transition-all duration-300 group">
            <div className="w-16 h-16 mx-auto mb-6 rounded-full bg-primary/20 flex items-center justify-center group-hover:scale-110 transition-transform duration-300">
              <i className="ri-phone-line text-3xl text-primary"></i>
            </div>
            <h3 className="font-display text-xl font-semibold text-white mb-3">
              Call Us
            </h3>
            <a 
              href="tel:+15867899699"
              className="text-gray-300 hover:text-primary transition-colors cursor-pointer"
            >
              (586) 789-9699
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}
